import { shouldLogOutOnForbidden } from '@/lib/api/twoFactorEnrollment';
import {
  dispatchCheckApiError,
  dispatchLogOut,
  MainContext,
} from '@/store/main/actionsMain';
import { getSamlConnections } from '@/lib/api/saml';

import { AxiosError } from 'axios';
import { ApiErrorResponse } from '@/interfaces/api/general/errorResponses';

export const actionGetCompanySAMLSetting = async (
  context: MainContext,
  payload: {
    companyId: string;
  }
) => {
  try {
    return await getSamlConnections(payload.companyId);
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};
